var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import React, { Component } from 'react';
import GlycemicMedicationDetailsCardAPI from './glycemic-medication-details-card-api';
import { ReactComponent as Repeat } from '../../assets/images/global/repeat.svg';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import './glycemic-medication-details-card.css';
import { bool, eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Card, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
const legends = [
    {
        color: 'signal-green-60',
        label: MessageService.translate('tws.read-items'),
        value: MessageService.translate('tws.read-items')
    },
    {
        color: 'signal-yellow-45',
        label: MessageService.translate('tws.unread-items'),
        value: MessageService.translate('tws.unread-items')
    }
];
let GlycemicMedicationDetailsCard = class GlycemicMedicationDetailsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick, scheduleSequence, barcode } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        barcode,
                        scheduleSequence,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        canUndo: bool,
        onClick: eventListener,
    }; }
    static { this.defaultProps = {
        canUndo: true,
    }; }
    renderResetButton() {
        const { read, canUndo } = this.props;
        return (React.createElement(React.Fragment, null, read && canUndo && (React.createElement("div", { className: 'c-glycemic-medication-details__reset-button' },
            React.createElement("div", { className: 'c-glycemic-medication-details__reset-container', onClick: () => this.handleClick() },
                React.createElement(Repeat, null),
                React.createElement(Text, { className: 'c-glycemic-medication-details__reset-button-text' }, MessageService.translate('text.undo')))))));
    }
    renderIndicatorColorStatus() {
        const { read } = this.props;
        return (React.createElement("div", { style: { backgroundColor: read ? '#009957' : '#FFCD05' }, className: 'c-administration-process__indicator-color' }));
    }
    renderDescriptionName() {
        const { materialDescription } = this.props;
        return (this.renderItemTitle(materialDescription));
    }
    renderItemTitle(title) {
        return (React.createElement("div", { className: 'c-glycemic-medication-details__description-name' },
            React.createElement(Text, { className: 'c-glycemic-medication-details__description-name-text' }, title)));
    }
    renderField() {
        const { read } = this.props;
        return (React.createElement("div", { className: 'c-glycemic-medication-details__container', style: { opacity: !read ? '0.5' : '1' } },
            React.createElement("div", { className: 'c-glycemic-medication-details__container-status' },
                this.renderIndicatorColorStatus(),
                this.renderDescriptionName(),
                this.renderContent()),
            this.renderResetButton()));
    }
    renderContent() {
        const { doseQuantity, unitMeasureDoseCode, schedules } = this.props;
        return (React.createElement("div", { className: 'c-glycemic-medication-details__content' },
            React.createElement("div", { className: 'c-glycemic-medication-details-card__content-up' },
                React.createElement("div", { className: 'c-glycemic-medication-details-card__content-up-left' }, unitMeasureDoseCode && (this.renderDefaultItem(MessageService.translate('label.unit-of-measurement'), unitMeasureDoseCode, ''))),
                React.createElement("div", { className: 'c-glycemic-medication-details-card__content-up-right' }, doseQuantity && (this.renderDefaultItem(MessageService.translate('text.dose'), String(doseQuantity), 'padding-right')))),
            React.createElement("div", { className: 'c-glycemic-medication-details-card__content-down' }, schedules && (this.renderDefaultItem(MessageService.translate('text.observation'), schedules, '')))));
    }
    renderDefaultItem(textTitle, itemValue, className) {
        return (React.createElement("div", { className: `c-glycemic-medication-details-card__default-infos ${className}` },
            React.createElement(Text, { className: 'c-glycemic-medication-details-card__default-title' }, textTitle),
            React.createElement(Text, { className: 'c-glycemic-medication-details-card__default-text' }, itemValue ?? itemValue)));
    }
    render() {
        return (React.createElement(Card, { className: 'c-glycemic-medication-details', width: 12, selectionType: SelectionType.SINGLE, superscription: legends, uuid: "53a58551-40f4-4ae8-aae5-28db5b6d4a08" }, this.renderField()));
    }
};
GlycemicMedicationDetailsCard = __decorate([
    AwesomeComponent({ api: GlycemicMedicationDetailsCardAPI, type: ComponentType.DATA_DISPLAY })
], GlycemicMedicationDetailsCard);
export default GlycemicMedicationDetailsCard;
//# sourceMappingURL=glycemic-medication-details-card.js.map